import React, { useState,useRef } from "react";

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Growl } from 'primereact/growl';
import { Paginator } from 'primereact/paginator';
import servicioFormatos from "../../../servicio/ServicioFormatos";
import servicioObjetos from "../../../servicio/ServicioObjetos";
import servicioHttp from "../../../servicio/ServicioHttp";

import {ModalEliminar} from './ModalEliminar';
import {ModalSuspender} from './ModalSuspender';
import { ModalDetalleMovimientos } from './ModalDetalleMovimientos';

export const TablaResultados = (props) => {

    const {paginacion,
        inicio,cambiaPagina,funcionBusqueda}=props;

    const [mostrarElModalEliminar, setMostrarElModalEliminar]=useState(false);
    const [nombreArchivoTxt,setNombreArchivoTxt]=useState(null);
    const [mostrarElModalLiberar,setMostrarElModalLiberar]=useState(false);
    const [loteIdImss, setLoteIdImss] =useState(null);
    const [verDetalle,setVerDetalle] =useState(false);
    const [idLote,setIdLote]=useState(null);
    const [paginacionDetalle,setPaginacionDetalle]=useState({});

    let growl = useRef(null);

    const plantillaOpciones = (rowData, column) => {
        let {estado,loteIdImss} =rowData;
        return <div className="p-grid">
            {((estado===0 || estado===-1 || estado===2) && servicioObjetos.esObjetoVacio(loteIdImss)) ?<div className="p-col-12 p-md-12">
                <Button label="Eliminar" icon="pi-md-delete" 
                onClick={() => mostrarModalEliminar(rowData)} className="p-button-danger flat-btn"/>
            </div>:null}

            {((estado===2) && !servicioObjetos.esObjetoVacio(loteIdImss)) ? <div className="p-col-12 p-md-12">
                <Button label="Liberar" icon="pi-md-accessibility" 
                onClick={() => mostrarModalLiberar(rowData)} className="p-button-warning flat-btn"/>
            </div>:null}
            <div className="p-col-12 p-md-12">
                <Button label="Ver detalle txt" icon="pi-md-remove-red-eye" 
                onClick={() => mostrarModalDetalle(rowData)} className="p-button-success"/>
            </div>                    
        </div>
    }

    const mostrarModalEliminar = (rowData) => {
        let {nombreArchivo,id} =rowData;
        setMostrarElModalEliminar(true);
        setNombreArchivoTxt(nombreArchivo);
        setIdLote(id);
    }

    const cerrarModalEliminar = () => {
        setMostrarElModalEliminar(false);
    }

    const eliminarLoteBd= () => {
        servicioHttp.consumirPostHttp("lote/eliminar.json",{"id":idLote}).then(response => {            
            cerrarModalEliminar();
            funcionBusqueda();
            let { data } = response;
            growl.current.show({ severity: data.error ? 'error' : 'info', summary: 'Respuesta', detail: data.mensaje, sticky: true });
        }).catch(error => {

        });        
    }



    const mostrarModalLiberar = (rowData) => {
        let {loteIdImss, nombreArchivo,id} = rowData;
        setMostrarElModalLiberar(true);
        setLoteIdImss(loteIdImss);
        setNombreArchivoTxt(nombreArchivo);
        setIdLote(id);
    }

    const cerrarModalLiberar = () => {
        setMostrarElModalLiberar(false);
    }

    const liberarLoteDb = () => {
        servicioHttp.consumirPostHttp("lote/liberar.json", { "id": idLote }).then(response => {
            cerrarModalLiberar();
            let { data } = response;
            growl.current.show({ severity: data.error ? 'error' : 'info', summary: 'Respuesta', detail: data.mensaje, sticky: true });
        }).catch(error => {

        });
    }

    const mostrarModalDetalle = (rowData) => {
        let { id, nombreArchivo } = rowData;
        setNombreArchivoTxt(nombreArchivo);
        let paginacionRequest={
            registrosPorPagina:2000,
            numeroPagina:0,
            restriccionesDinamicas:[{
                "tipoRestriccion":"eq",
                "nombrePropiedad":"alias_ttLoteSolicitudIdse.id",
                "valorPropiedad":id
            }]
        }
        servicioHttp.consumirPostHttp("movimiento/paginar.json", paginacionRequest).then(response => {
            setVerDetalle(true);
            setPaginacionDetalle(response.data.objeto);
        }).catch(error => {

        });
    }

    const cerrarModalDetalle = () => {
        setVerDetalle(false);
    }

    const onIndexTemplate = (data, props) => {
        return (props.rowIndex + 1) + inicio;
    }

    const columnaempresa = (rowData, column) => {
        return <div>{rowData.registroPatronal} - {rowData.razonSocial} - {rowData.nombreCortoEmpresa}</div>;
    }

    const columnaFechaRecepcion = (rowData, column) => {
        return <div>{servicioFormatos.formatearFechaString(rowData.fechaRecepcionEmica)}</div>;
    }

    const columnaFechaRespuestaImss = (rowData, column) => {
        return <div>{servicioFormatos.formatearFechaString(rowData.fechaRespuestaImss)}</div>;
    }

    const columnaFechaObtencionNumeroLote = (rowData, column) => {
        return <div>{servicioFormatos.formatearFechaString(rowData.fechaObtencionNumeroLote)}</div>;
    }

    const columnaUsuario = (rowData, column) => {
        return <div>{rowData.usuario}  - {rowData.correoUsuario}</div>;
    }

    const columnaEstado = (rowData, column) => {
        return obtenerEstado(rowData);
    }

    const obtenerEstado = (rowData) => {
        let response = "";
        switch (rowData.estado) {
            case -1:
                response = <strong style={{color: "yellow"}}>Se está enviando al IMSS</strong>;
                break;
            case 0:
                response = <strong style={{color: "black"}}>En espera de ser enviado</strong>;
                break;
            case 1:
                response = <strong style={{color: "blue"}} >Recibido por el IMSS,ya se cuenta con número de lote, esperando el AFIL</strong>;
                break;
            case 2:
                if (servicioObjetos.esObjetoVacio(rowData.loteIdImss)) {
                    response = <strong style={{color: "red"}}>Enviado al IMSS con errores</strong>;
                }
                else {
                    response = <strong style={{color: "green"}}>Recibido por el IMSS ya se cuenta con el AFIL</strong>;
                }

                break;
            default:
                response = "";

        }
        return response;
    }

    const columnaIntentos = (rowData, column) => {
        return <div>{rowData.intentos===0?(rowData.intentos+1):rowData.intentos}</div>
    }

    const columnaNumeroLote = (rowData, column) =>{
        return <div>{servicioObjetos.esObjetoVacio(rowData.loteIdImss)?"":<strong>{rowData.loteIdImss}</strong>}</div>;
    }

    return (
        <div className="card card-w-title">
            <Growl ref={growl} />
            <DataTable
                value={paginacion.datos}
                responsive={true}
                header="Empresa"
                autoLayout={true} 
                selectionMode="single">
                <Column field="Index" header="Número" body={onIndexTemplate} />
                <Column header="Opciones" body={plantillaOpciones} />
                <Column field="nombreArchivo" header="Nombre del Archivo" />
                <Column header="Número de Lote" body={columnaNumeroLote}/>
                <Column header="Estado" body={columnaEstado}/>
                <Column header="Intentos de Envío" body={columnaIntentos}/>
                <Column header="Empresa" body={columnaempresa}/>
                <Column header="Fecha Recepción en EMICA" body={columnaFechaRecepcion}/>
                <Column header="Fecha obtención Número Lote" body={columnaFechaObtencionNumeroLote}/>
                <Column header="Fecha de descarga Afil" body={columnaFechaRespuestaImss}/>
                <Column header="Cargado por:" body={columnaUsuario}/>                
            </DataTable>

            <Paginator first={inicio} rows={paginacion.registrosPorPagina} 
            totalRecords={paginacion.registrosTotales} 
            onPageChange={cambiaPagina} 
            rowsPerPageOptions={[10, 20, 40, 60, 80, 100]} 
            template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink RowsPerPageDropdown" 
            currentPageReportTemplate={"Total: "+paginacion.registrosTotales+", Página ({currentPage} de {totalPages})"} />

            <ModalEliminar mostrar={mostrarElModalEliminar} cerrarModal={cerrarModalEliminar} 
            nombreArchivoTxt={nombreArchivoTxt} funcionEliminar={eliminarLoteBd}/>

            <ModalSuspender mostrar={mostrarElModalLiberar} cerrar={cerrarModalLiberar} 
            nombreArchivoTxt={nombreArchivoTxt} funcionSi={liberarLoteDb} loteIdImss={loteIdImss}/>

            <ModalDetalleMovimientos mostrar={verDetalle} cerrar={cerrarModalDetalle}
            nombreArchivo={nombreArchivoTxt} paginacion={paginacionDetalle} />
        </div>
    );
}